/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback} from 'react'

import useAllSelectionsField from './useAllSelectionsField.js'

const useMultiSelectionNestedFilter = ({allSelectionsId, allSelectionsLabel, onChange, options, value}) => {
  const {hasAllOptionsChecked, defaultSelections, onSelectAll} = useAllSelectionsField({
    allSelectionsId,
    allSelectionsLabel,
    onChange,
    value
  })

  const hasAllSelectionsField = Boolean(allSelectionsLabel)

  const getHasAllOptionsChecked = ({selections}) =>
    options.every(({nestedItems}) => nestedItems.every(({id}) => selections.includes(id)))

  const handleSelectGroupItem = useCallback(
    ({nestedItems}) => {
      const currentValue = value.filter(id => id !== allSelectionsId)
      const nestedItemsIds = nestedItems.map(({id}) => id)
      const isPreviouslySelected = nestedItemsIds.every(id => currentValue.includes(id))

      const newSelections = isPreviouslySelected
        ? currentValue.filter(id => !nestedItemsIds.includes(id))
        : [...currentValue, ...nestedItemsIds]

      const areAllOptionsSelected = getHasAllOptionsChecked({selections: newSelections})
      if (allSelectionsLabel && areAllOptionsSelected) return onChange(defaultSelections)

      const hasSelections = Boolean(newSelections.length)
      const currentSelections = hasSelections ? newSelections : defaultSelections

      onChange(currentSelections)
    },
    [allSelectionsId, allSelectionsLabel, onChange, value]
  )

  const setNewSelections = useCallback(
    ids => {
      const currentSelections = ids.filter(id => id !== allSelectionsId)
      const hasAllOptionsChecked = getHasAllOptionsChecked({selections: ids})
      allSelectionsLabel && hasAllOptionsChecked ? onChange(defaultSelections) : onChange(currentSelections)
    },
    [allSelectionsId, allSelectionsLabel, onChange, value]
  )

  const handleSelectNestedItems = useCallback(setNewSelections, [value])

  return {
    hasAllOptionsChecked,
    hasAllSelectionsField,
    onSelectAll,
    onSelectGroupItem: handleSelectGroupItem,
    onSelectNestedItems: handleSelectNestedItems
  }
}

export default useMultiSelectionNestedFilter
